
import { ANALYTICS_URI } from 'library-@/config/apiConfig';

const homePageHref = {
    'Homepage': `${ANALYTICS_URI}/search/input/simple`,
    'Advanced search': `${ANALYTICS_URI}/search/input/field`,
    'Expert search': `${ANALYTICS_URI}/search/input/field/project`
};

export const getHeaderLogoHref = (homePage) => {

    if (homePageHref[homePage]) {
        return homePageHref[homePage];
    }

    return ANALYTICS_URI;
};
